import { render } from "./PersonalDashboard.vue?vue&type=template&id=67cfcf33&scoped=true"
import script from "./PersonalDashboard.vue?vue&type=script&lang=js"
export * from "./PersonalDashboard.vue?vue&type=script&lang=js"

import "./PersonalDashboard.vue?vue&type=style&index=0&id=67cfcf33&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cfcf33"]])

export default __exports__